<div class="drp-host">
  <button
    class="drp-trigger"
    type="button"
    aria-haspopup="dialog"
    [attr.aria-expanded]="open()"
    [attr.aria-label]="ariaLabel() + ' ' + displayRange()"
    (click)="toggle()"
  >
    <i class="ri-calendar-line text-sm" aria-hidden="true"></i>
    {{ displayRange() }}
  </button>
</div>

<ng-template #dropdownTpl>
  <div
    class="drp-dropdown"
    role="dialog"
    [attr.aria-label]="ariaLabel()"
    [style.top.px]="dropdownTop() ?? null"
    [style.bottom.px]="dropdownBottom() ?? null"
    [style.left.px]="dropdownLeft() ?? null"
  >
    <div class="drp-nav">
      <button
        type="button"
        class="drp-nav-btn"
        aria-label="Předchozí měsíc"
        (click)="prevMonth()"
      >
        <i class="ri-arrow-left-s-line text-sm" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="drp-month-label drp-month-label-btn"
        [attr.aria-pressed]="mode() === 'years'"
        aria-label="Vybrat rok"
        (click)="toggleYears()"
      >
        {{ viewMonthLabel() }}
        <i class="ri-arrow-down-s-line text-sm" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="drp-nav-btn"
        aria-label="Další měsíc"
        (click)="nextMonth()"
      >
        <i class="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
      </button>
    </div>

    @if (mode() === 'years') {
      <div class="drp-years">
        <div class="drp-nav drp-years-nav">
          <button
            type="button"
            class="drp-nav-btn"
            aria-label="Předchozí roky"
            (click)="prevYears()"
          >
            <i class="ri-arrow-left-s-line text-sm" aria-hidden="true"></i>
          </button>
          <span class="drp-years-label">{{ yearsLabel() }}</span>
          <button
            type="button"
            class="drp-nav-btn"
            aria-label="Další roky"
            (click)="nextYears()"
          >
            <i class="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
          </button>
        </div>
        <div class="drp-years-grid" role="grid" aria-label="Výběr roku">
          @for (year of yearsGrid(); track year) {
            <button
              type="button"
              class="drp-year"
              role="gridcell"
              [class.is-current]="isViewYear(year)"
              (click)="selectYear(year)"
            >
              {{ year }}
            </button>
          }
        </div>
      </div>
    } @else {
      <div class="drp-grid" role="grid">
        @for (label of dayLabels; track label) {
          <div class="drp-day-label" aria-hidden="true">{{ label }}</div>
        }
        @for (day of calendarDays(); track day.date.toISOString()) {
          <button
            type="button"
            class="drp-day"
            role="gridcell"
            [attr.aria-label]="dayAria(day.date)"
            [attr.aria-selected]="isSelected(day.date)"
            [attr.aria-current]="day.isToday ? 'date' : null"
            [class.out-of-month]="!day.inMonth"
            [class.is-today]="day.isToday"
            [class.is-range-start]="isRangeStart(day.date)"
            [class.is-range-end]="isRangeEnd(day.date)"
            [class.is-in-range]="isInRange(day.date)"
            (click)="selectDay(day.date)"
            (mouseenter)="onDayHover(day.date)"
            (mouseleave)="onDayLeave()"
          >
            {{ day.date.getDate() }}
          </button>
        }
      </div>
    }
  </div>
</ng-template>
